import React from "react";
import Monetization from "./monetization";
import Overview from "./overview";
import OurPlatform from "./ourPlatform";
import { WideContainer } from "components/mui/containers/PxftContainer";
import BasicRowA from "components/mui/containers/basicRowA";
import BasicRowC from "components/mui/containers/basicRowC";
import { BlueDivider, YellowDivider } from "components/mui/divider/divider";
import LatestPosts from "./latestPosts";
import { Grid } from "@mui/material";

const HomeArticle = ({ blogs }) => {
  const adDes = {
    title: "Agentic \n Analytics & \nPredictive AI",
    content:
      "Beyond dashboards. Our AI agents continuously evaluate performance, predict revenue outcomes, and act on insights in real time — turning data into automatic revenue gains.",
    src: "images/home/ad-monestatics.png",
  };
  const advsDes = {
    title: "We Power the World’s Biggest Brands",
    src: "images/home/topadvs.png",
  };
  return (
    <WideContainer className="home-article-container">
      <LatestPosts posts={blogs} />
      <Overview />
      <OurPlatform />
      <Monetization />
      <div style={{ position: "relative" }} className="ad-container">
        <YellowDivider
          width="60%"
          height="20px"
          marginTop="-30px"
          marginRight="0"
        />
        <BlueDivider
          width="40%"
          height="20px"
          marginTop="30px"
          marginRight="0"
        />
        <Grid pt={{ lg: 0, xs: 5 }}>
          <BasicRowA
            title={adDes.title}
            contents={adDes.content}
            picSrc={adDes.src}
            button={false}
            long={false}
          />
        </Grid>
      </div>
      <div style={{ position: "relative" }} className="inventory-container">
        <YellowDivider
          width="40%"
          height="20px"
          marginLeft="0"
          className="left-align"
        />
      </div>
      <div style={{ position: "relative" }}>
        <BlueDivider width="55%" height="30px" marginTop="0" marginRight="0" />
        <BasicRowC title={advsDes.title} picSrc={advsDes.src} />
      </div>
    </WideContainer>
  );
};

export default HomeArticle;
